export enum Operation {
  INDEX = 'INDEX',
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  NEW = 'NEW',
  VALIDATE = 'VALIDATE',
}
